import React, { useEffect, useMemo, useRef, useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../../Components/FieldInput"
import Button from "../../Components/Button"
import RasiKattam from "../../Components/RasiKattam"
import AmsaKattam from "../../Components/AmsaKattam"
import FieldSelect from "../../Components/FieldSelect"
import FieldMultiSelect from "../../Components/FieldMultiSelect"
import axios from "axios"
import API from '../../Common/API'
import { AiFillCloseCircle } from "react-icons/ai"
import { useHistory } from 'react-router-dom'
// import PreviewRegistration from "./PreviewRegistration"
import { setAlert, setLanguage } from '../../Store/Theme/actions'
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import Dialog from "../../Components/Dialog"
import Spinner from "../../Components/Loaders/Spinner"
// import LanguageSwitcher from "../../Components/LanguageSwitcher"

const profileTypes = [{ text: 'Bride', value: 'bride' }, { text: 'Groom', value: 'groom' }]
const tProfileTypes = [{ text: 'மணமகள்', value: 'bride' }, { text: 'மணமகன்', value: 'groom' }]
const yesOrNo = [{ text: "Yes", value: true }, { text: "No", value: false }]
const salaryMode = [{ text: 'Month', value: 'month' }, { text: 'Year', value: 'year' }]
const tYesOrNo = [{ text: "ஆம்", value: true }, { text: "இல்லை", value: false }]
const tSalaryMode = [{ text: "மாதம்", value: true }, { text: "ஆண்டு", value: false }]
const pathams = [{ text: '1-ஆம் பாதம்', value: '1-ஆம் பாதம்' }, { text: '2-ஆம் பாதம்', value: '2-ஆம் பாதம்' }, { text: '3-ஆம் பாதம்', value: '3-ஆம் பாதம்' }, { text: '4-ஆம் பாதம்', value: '4-ஆம் பாதம்' }]
const maritalStatus = [{ text: 'First Marriage', value: 'Never Married' }, { text: 'Divorced', value: 'Divorced' }, { text: 'Widow', value: 'Widow' }, { text: 'Widower', value: 'Widower' },{text:'Seperated',value:'seperated'}]
const tMaritalStatus = [{ text: 'முதல் திருமணம்', value: 'Never Married' }, { text: 'விவாகரத்து பெற்றவர்', value: 'Divorced' }, { text: 'விதவை', value: 'Widow' }, { text: 'மனைவியை இழந்தவன்', value: 'Widower' },{text:"பிரிந்தனர்",value:'seperated'}]
const childOptions = [{ text: "0", value: "0" }, { text: "1", value: "1" }, { text: "2", value: "2" }, { text: "3", value: "3" }, { text: "4", value: "4" }, { text: "5", value: "5" }, { text: 'More than 5', value: 'More than 5' }]


const initialRegisterForm = {
    profileType: '',
    refId:'',
    educationalQualification: '',
    firstName: '',
    lastName: '',
    surname: '',
    tFirstName: '',
    tLastName: '',
    tSurname: '',
    height: '',
    heightInFeet: '',
    otherEducationalQualification:'',
    profession: '',
    occupationDetail: "",
    salaryMode: '',
    dateOfBirth: '',
    images: [],
    rasiKattam: {},
    amsaKattam: {},
    password: '',
    confirmPassword: '',
    contactInformation: {
        mobileNumber: '',
        whatsappNumber: '',
        isSameAddress: false,
        email: '',
    },
    nativeAddress: {
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            district: '',
            pinCode: ''
        },
        presentAddress: {
            addressLine1: '',
            addressLine2: '',
            district: '',
            city: '',
            state: '',
            pinCode: '',
            district: '',
        },
    familyInformation: {
        fatherFirstName: '',
        fatherLastName: '',
        fatherSurname: '',
        motherFirstName: '',
        motherLastName: '',
        motherSurname: '',
        fatherNative: '',
        motherNative: '',
        fatherOccupation: '',
        motherOccupation: '',
        isFatherAlive: true,
        isMotherAlive: true,
        numberOfSibilings: 0,
        numberOfMaleSibilings: 0,
        numberOfFemaleSibilings: 0,
        siblingsDetails:''
    },
    additionalInformation: {
        zodiacSign: '',
        star: '',
        padham: '',
        flaws: [],
        // ascendant: '',
        expectedZodiacSigns: [],
        expectedStars: [],
        expectedPersonality: [],
        expectedEducationalQualification: '',
        expectedOccupation: '',
        expectedSalary: '',
        expectedStatus: '',
        expectation:"",
    }
}

const initialFamilyForm = {
    fatherFirstName: '',
    fatherLastName: '',
    fatherSurname: '',
    motherFirstName: '',
    motherLastName: '',
    motherSurname: '',
    fatherNative: '',
    motherNative: '',
    fatherOccupation: '',
    motherOccupation: '',
    isFatherAlive: true,
    isMotherAlive: true,
    numberOfSibilings: 0,
    numberOfMaleSibilings: 0,
    numberOfFemaleSibilings: 0,
    assetInfo:''
}

const initialAdditionalForm = {
    zodiacSign: '',
    star: '',
    flaws: [],
    // ascendant: '',
    expectedZodiacSigns: [],
    expectedStars: [],
    expectedPersonality: [],
    expectedEducationalQualification: [],
    expectedOccupation: '',
    expectedSalary: '',
    expectedStatus: '',
}

const initialContactForm = {
    mobileNumber: '',
    whatsappNumber: [],
    nativeAddress: {
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        district: '',
        pinCode: ''
    },
    presentAddress: {
        addressLine1: '',
        addressLine2: '',
        district: '',
        city: '',
        state: '',
        pinCode: '',
        district: '',
    },
    isSameAddress: false,
    email: ''
}

const EditUser = ({ match, embedded = false, onClose, onSaved, compactMode = false, onActionsReady }) => {

    const [page1, setPage1] = useState(true)
    const [page2, setPage2] = useState(false)
    const [page3, setPage3] = useState(false)
    const [page4, setPage4] = useState(false)
    const [page5, setPage5] = useState(false)
    const [files, setFiles] = React.useState([]);
    const educationList = useSelector((state) => state.auth.educationList)
    const fullEducations = useSelector((state) => state.auth.fullEducations)
    const [pType, setPType] = useState()
    const zodiacSigns = useSelector((state) => state.auth.zodiacSigns)
    const flaws = useSelector((state) => state.auth.flaws)
    const [fileUrls, setFileUrls] = useState([])
    const [rasiValues, setRasiValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);

    const [amsaValues, setAmsaValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);
    const status = useSelector((state) => state.auth.status)
    const allStars = useSelector((state) => state.auth.allStars)
    const occupation = useSelector((state) => state.auth.occupation)
    const [previewDialog, setPreviewDialog] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const { t } = useTranslation()
    const lang = useSelector((state) => state.theme.language)
    const [screenLoading, setScreenLoading] = useState(false)
    const [userDetails, setUserDetails] = useState(initialRegisterForm)
    const [loading, setLoading] = useState(true)
    const [openSaveAlert,setOpenSaveAlert] = useState(false)
    const [heightType, setHeightType] = useState('cm')
    const dhisa = useSelector((state) => state.auth.dhisa)
    const tDhisa = useSelector((state) => state.auth.tDhisa)
    const [childDetails,setChildDetails]= useState(false)
    const tStatus = useSelector((state)=>state.auth.tStatus)
    const tOccupation = useSelector((state)=>state.auth.tOccupation)
    const tFlaws = useSelector((state)=>state.auth.tFlaws)
    const editUserId = match?.params?.id

    const closeEditor = () => {
        if (embedded && typeof onClose === 'function') {
            onClose()
            return
        }
        history.goBack()
    }

    // Ref so the SlideOver header always calls the latest handleSaveAll
    const handleSaveRef = useRef(null)

    useEffect(() => {
        if (typeof onActionsReady !== 'function') return
        onActionsReady({
            onCancel: cancel,
            onSave: () => handleSaveRef.current?.(),
            submitDisabled,
            cancelLabel: t('Cancel'),
            saveLabel: t('Save'),
            savingLabel: t('Saving…') || 'Saving…',
        })
        return () => { onActionsReady(null) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitDisabled])

    useEffect(() => {
        if (!editUserId) return
        try {
            axios.all([API.get(`/user/getUserDetailsById/${editUserId}`), API.get('/common/getEducations'), API.get('/common/getZodiacSign'), API.get('/common/getAllFlaws'), API.get('/common/getStatusList'), API.get('/common/getOccupations'), API.get('/common/getAllStars')]).then((axios.spread((userRes, eduRes, zodiacRes, flawRes, statRes, occuRes, starRes) => {
                let responseValues = userRes.data.data
                responseValues.presentAddress = responseValues.contactInformation?.presentAddress ?? { addressLine1: '', addressLine2: '', city: '', state: '', district: '', pinCode: '' }
                responseValues.nativeAddress = responseValues.contactInformation?.nativeAddress ?? { addressLine1: '', addressLine2: '', city: '', state: '', district: '', pinCode: '' }
                // Coerce pinCode to string (DB may store as number)
                if (responseValues.presentAddress.pinCode != null) responseValues.presentAddress.pinCode = String(responseValues.presentAddress.pinCode)
                if (responseValues.nativeAddress.pinCode != null) responseValues.nativeAddress.pinCode = String(responseValues.nativeAddress.pinCode)
                if (!responseValues.contactInformation) responseValues.contactInformation = { isSameAddress: false }
                setUserDetails({...userDetails,...responseValues})
                checkForKids(userRes.data.data.maritalStatus)
                const rasiRaw = userRes?.data?.data?.rasiKattam
                const amsaRaw = userRes?.data?.data?.amsaKattam
                // Handle both array (legacy) and {rasiPlanets:[]} (current) formats
                const rasiPlanets = Array.isArray(rasiRaw) ? rasiRaw : rasiRaw?.rasiPlanets
                const amsaPlanets = Array.isArray(amsaRaw) ? amsaRaw : amsaRaw?.amsaPlanets
                if (rasiPlanets && rasiPlanets.length !== 0) setRasiValues(rasiPlanets)
                if (amsaPlanets && amsaPlanets.length !== 0) setAmsaValues(amsaPlanets)
                setLoading(false)
            })))
        } catch (err) {
            console.log(err)
        }
    }, [editUserId])

    const registerFormSchema = Yup.object().shape({
        profileType: Yup.string().required("Profile type is required"),
        refId:Yup.string().nullable(),
        // educationalQualification: Yup.string().required("Educational Qualification is required"),
        otherEducationalQualification:Yup.string().required("Educational Qualification is required"),
        firstName: Yup.string().required("First Name is required"),
        surname: Yup.string().required("Surname is required"),
        tFirstName: Yup.string().nullable(),
        tLastName: Yup.string().nullable(),
        tSurname: Yup.string().nullable(),
        dateOfBirth: Yup.string().required("Date of birth is required"),
        heightInFeet: Yup.string().nullable(),
        profession: Yup.string().nullable(),
        height: Yup.number().required("Required"),
        images: Yup.array(),
        rasiKattam: Yup.object(),
        amsaKattam: Yup.object(),
        birthTime: Yup.string().nullable(),
        birthPlace: Yup.string().nullable(),
        thisaiIruppu: Yup.string().nullable(),
        thisaiIruppuDate: Yup.string().nullable(),
        thisaiIruppuMonth: Yup.string().nullable(),
        thisaiIruppuYear: Yup.string().nullable(),
        maritalStatus:Yup.string().nullable(),
        noOfChild : Yup.string().nullable(),
        childDetails : Yup.string().nullable(),
        familyInformation: Yup.object().shape({
            fatherFirstName: Yup.string().required("Required"),
            fatherSurname: Yup.string().required("Required"),
            motherFirstName: Yup.string().required("Required"),
            motherSurname: Yup.string().required("Required"),
            fatherOccupation: Yup.string().nullable(),
            fatherNative: Yup.string().nullable(),
            motherNative: Yup.string().nullable(),
            motherOccupation: Yup.string().nullable(),
            isFatherAlive: Yup.boolean(),
            isMotherAlive: Yup.boolean(),
            numberOfSibilings: Yup.number(),
            numberOfMaleSibilings: Yup.number(),
            numberOfFemaleSibilings: Yup.number(),
            marriedMaleSiblings: Yup.number(),
    marriedFemaleSiblings:Yup.number(),
            siblingsDetails:Yup.string().nullable(),
            assetInfo:Yup.string().nullable()
        }),
        contactInformation: Yup.object().shape({
            mobileNumber: Yup.string().required("Mobile number is required"),
            whatsappNumber: Yup.string().nullable(), 
            isSameAddress: Yup.boolean(),
            email: Yup.string().nullable(),
        }),
        nativeAddress: Yup.object().shape({
                addressLine1: Yup.string().nullable(),
                addressLine2: Yup.string().nullable(),
                city: Yup.string().nullable(),
                state: Yup.string().nullable(),
                district: Yup.string().nullable(),
                pinCode: Yup.string().nullable()
            }),
            presentAddress: Yup.object().shape({
                addressLine1: Yup.string().required("Address Line 1 is required"),
                addressLine2: Yup.string().nullable(),
                city: Yup.string().required("City is required"),
                state: Yup.string().required("State is required"),
                district: Yup.string().required("District is required"),
                pinCode: Yup.string().transform(v => v == null ? '' : String(v)).matches(/^[0-9]{6}$/, "Enter a valid 6-digit pincode").required("Pincode is required")
            }),
        additionalInformation: Yup.object().shape({
            zodiacSign: Yup.string().required("Required"),
            star: Yup.string().required("Required"),
            padham: Yup.string().nullable(),
            flaws: Yup.array(),
            // ascendant: Yup.string().required("Required"),
            expectedZodiacSigns: Yup.array(),
            expectedStars: Yup.array(),
            expectedPersonality: Yup.array(),
            expectedEducationalQualification: Yup.string().nullable(),
            expectedOccupation: Yup.array(),
            expectedSalary: Yup.string().nullable(),
            expectedStatus: Yup.array(),
            expectation:Yup.string().nullable(),
            // password: Yup.string().required("Password is required"),
            // confirmPassword: Yup.string().required("Confirm Password is required"),
        })
    })

    const familyFormSchema = Yup.object().shape({
        fatherFirstName: Yup.string().required("Required"),
        fatherLastName: Yup.string().required("Required"),
        fatherSurname: Yup.string().required("Required"),
        motherFirstName: Yup.string().required("Required"),
        motherLastName: Yup.string().required("Required"),
        motherSurname: Yup.string().required("Required"),
        fatherOccupation: Yup.string().nullable(),
        fatherNative: Yup.string().nullable(),
        motherNative: Yup.string().nullable(),
        motherOccupation: Yup.string().nullable(),
        isFatherAlive: Yup.boolean(),
        isMotherAlive: Yup.boolean(),
        numberOfSibilings: Yup.number(),
        numberOfMaleSibilings: Yup.number(),
        numberOfFemaleSibilings: Yup.number()
    })

    const familyForm = useFormik({
        initialValues: userDetails?.familyInformation
            ? { ...initialFamilyForm, ...userDetails.familyInformation }
            : initialFamilyForm,
        validateOnMount: true,
        validationSchema: familyFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
        }
    })

    const additionalFormSchema = Yup.object().shape({
        zodiacSign: Yup.string().required("Required"),
        star: Yup.string().required("Required"),
        flaws: Yup.array(),
        // ascendant: Yup.string().required("Required"),
        expectedZodiacSigns: Yup.array(),
        expectedStars: Yup.array(),
        expectedPersonality: Yup.array(),
        expectedEducationalQualification: Yup.array(),
        expectedOccupation: Yup.array(),
        expectedSalary: Yup.string().nullable(),
        expectedStatus: Yup.array(),
        // password: Yup.string().required("Password is required"),
        // confirmPassword: Yup.string().required("Confirm Password is required"),
    })

    const additionalForm = useFormik({
        initialValues: userDetails?.additionalInformation
            ? { ...initialAdditionalForm, ...userDetails.additionalInformation }
            : initialAdditionalForm,
        validateOnMount: true,
        validationSchema: additionalFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
        }
    })

    const contactFormSchema = Yup.object().shape({
        mobileNumber: Yup.string().required("Mobile number is required"),
        // whatsappNumber: Yup.array(), 
        nativeAddress: Yup.object().shape({
            addressLine1: Yup.string().required("Address Line 1 is required"),
            addressLine2: Yup.string().nullable(),
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            district: Yup.string().required("District is required"),
            pinCode: Yup.string().required("Pincode is required")
        }),
        presentAddress: Yup.object().shape({
            addressLine1: Yup.string().required("Address Line 1 is required"),
            addressLine2: Yup.string().nullable(),
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            district: Yup.string().required("District is required"),
            pinCode: Yup.string().required("Pincode is required")
        }),
        isSameAddress: Yup.boolean(),
        email: Yup.string().nullable(),
    })


    const contactForm = useFormik({
        initialValues: userDetails?.contactInformation
            ? { ...initialContactForm, ...userDetails.contactInformation }
            : initialContactForm,
        validateOnMount: true,
        validationSchema: contactFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
        }
    })

    const registerForm = useFormik({
        initialValues: userDetails,
        validateOnMount: true,
        validationSchema: registerFormSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setSubmitDisabled(true)
            setScreenLoading(true)
            values.rasiKattam = { ...(values.rasiKattam?._id ? { _id: values.rasiKattam._id } : {}), rasiPlanets: rasiValues }
            values.amsaKattam = { ...(values.amsaKattam?._id ? { _id: values.amsaKattam._id } : {}), amsaPlanets: amsaValues }
            if (!values.tFirstName || values.tFirstName.toString().length === 0) {
                try {
                    const firstName = await API.post('/common/translate', { text: values.firstName })
                    values.tFirstName = firstName.data.data.translatedText
                } catch (_) {}
            }
            if (!values.tSurname || values.tSurname.toString().length === 0) {
                try {
                    const surName = await API.post('/common/translate', { text: values.surname })
                    values.tSurname = surName.data.data.translatedText
                } catch (_) {}
            }
            // Handle both "5.6" (decimal) and "5 ft 6 in" (already formatted) forms
            const hf = values.heightInFeet || ''
            if (hf.includes('ft')) {
                // already in "X ft Y in" format — leave as-is
            } else if (hf.includes('.')) {
                const [feet, inches] = hf.split('.')
                values.heightInFeet = `${feet || 0} ft ${inches || 0} in`
            } else {
                values.heightInFeet = hf // leave unchanged if unrecognised format
            }
            values.contactInformation.presentAddress = {...values.presentAddress}
            values.contactInformation.nativeAddress = {...values.nativeAddress}
            const formData = new FormData();
            formData.append('userData', JSON.stringify(values));
            API.post('/user/editUserByAdmin', values).then((res) => {
                if (res.status === 200) {
                    dispatch(setAlert({ type: 'success', title: 'Edit Success', subtitle: 'Profile Edited Successfully', active: true }))
                    setSubmitDisabled(false)
                    setScreenLoading(false)
                    if (typeof onSaved === 'function') {
                        onSaved(res.data?.data)
                    }
                }
            }).catch((err) => {
                setSubmitDisabled(false)
                setScreenLoading(false)
            })
        }
    })


    // ── Single save action — merges all sub-forms, skips multi-step validation ──
    const handleSaveAll = async () => {
        setSubmitDisabled(true)
        setScreenLoading(true)
        try {
            const values = {
                ...registerForm.values,
                familyInformation: familyForm.values,
                additionalInformation: additionalForm.values,
                contactInformation: {
                    ...contactForm.values,
                    presentAddress: { ...registerForm.values.presentAddress },
                    nativeAddress:  { ...registerForm.values.nativeAddress  },
                },
            }

            // Horoscope — always save as {rasiPlanets:[]} so load code can reliably read it back
            values.rasiKattam = { ...(values.rasiKattam?._id ? { _id: values.rasiKattam._id } : {}), rasiPlanets: rasiValues }
            values.amsaKattam = { ...(values.amsaKattam?._id ? { _id: values.amsaKattam._id } : {}), amsaPlanets: amsaValues }

            // heightInFeet normalisation
            const hf = values.heightInFeet || ''
            if (!hf.includes('ft') && hf.includes('.')) {
                const [ft, inch] = hf.split('.')
                values.heightInFeet = `${ft || 0} ft ${inch || 0} in`
            }

            // Tamil name fallbacks
            if (!values.tFirstName) {
                try { values.tFirstName = (await API.post('/common/translate', { text: values.firstName })).data.data.translatedText } catch (_) {}
            }
            if (!values.tSurname) {
                try { values.tSurname = (await API.post('/common/translate', { text: values.surname })).data.data.translatedText } catch (_) {}
            }

            const res = await API.post('/user/editUserByAdmin', values)
            if (res.status === 200) {
                dispatch(setAlert({ type: 'success', title: 'Saved', subtitle: 'Profile saved successfully', active: true }))
                if (typeof onSaved === 'function') onSaved(res.data?.data)
            }
        } catch (err) {
            dispatch(setAlert({ type: 'error', title: 'Error', subtitle: 'Failed to save profile', active: true }))
        } finally {
            setSubmitDisabled(false)
            setScreenLoading(false)
        }
    }
    // Keep ref in sync every render so the SlideOver header always calls the latest version
    handleSaveRef.current = handleSaveAll


    const convertHeight = (cm) => {
        if (!cm) return
        const totalInches = parseFloat(cm) * 0.3937;
        const feet = Math.floor(totalInches / 12);
        const inches = Math.round(totalInches % 12);
        registerForm.setFieldValue('heightInFeet', `${feet}.${inches}`)
    };

    const convertHeightToCm = (feet) => {
        if (!feet) return
        const cm = Math.round(parseFloat(feet) * 30.48);
        registerForm.setFieldValue('height', cm)
    }

    const validateForms = async (page) => {
        registerForm.setValues({ ...registerForm.values, additionalInformation: additionalForm.values, familyInformation: familyForm.values, contactInformation: contactForm.values, images: [...files], previewUrls: [...fileUrls], rasiKattam: [...rasiValues], amsaKattam: [...amsaValues] })
        if (page === 1) {
            const errors = await registerForm.validateForm(); // Trigger validation
            registerForm.setTouched(
                Object.keys(registerForm.values).reduce((acc, key) => {
                    if (typeof registerForm.values[key] === 'object') {
                        acc[key] = Object.keys(registerForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );
            if (Object.keys(errors).length === 0) {
                setPage1(false);
                setPage2(true);
                setPage3(false);
                setPage4(false);
                setPage5(false);
            }
        } else if (page === 2) {
            const errors = await familyForm.validateForm(); // Trigger validation
            familyForm.setTouched(
                Object.keys(familyForm.values).reduce((acc, key) => {
                    if (typeof familyForm.values[key] === 'object') {
                        acc[key] = Object.keys(familyForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );
            if (Object.keys(errors).length === 0) {
                setPage1(false)
                setPage2(false)
                setPage3(true)
                setPage4(false)
                setPage5(false)
            }
        } else if (page === 3) {
            const errors = await additionalForm.validateForm(); // Trigger validation
            additionalForm.setTouched(
                Object.keys(additionalForm.values).reduce((acc, key) => {
                    if (typeof additionalForm.values[key] === 'object') {
                        acc[key] = Object.keys(additionalForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );
            if (Object.keys(errors).length === 0) {
                setPage1(false)
                setPage2(false)
                setPage3(false)
                setPage4(true)
                setPage5(false)
            }
        } else if (page === 4) {
            const errors = await contactForm.validateForm(); // Trigger validation
            contactForm.setTouched(
                Object.keys(contactForm.values).reduce((acc, key) => {
                    if (typeof contactForm.values[key] === 'object') {
                        acc[key] = Object.keys(contactForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );
            console.log(Object.keys(errors))
            if (Object.keys(errors).length === 0) {
                setPage1(false)
                setPage2(false)
                setPage3(false)
                setPage4(false)
                setPage5(true)
            }
        } else if (page === 5) {
            setPage1(false)
            setPage2(false)
            setPage3(false)
            setPage4(false)
            setPage5(true)
            setPreviewDialog(true)
        }
    }

    const backPage = (page) => {
        if (page === 1) {
            setPage1(true)
            setPage2(false)
            setPage3(false)
            setPage4(false)
            setPage5(false)
        } else if (page === 2) {
            setPage1(false)
            setPage2(true)
            setPage3(false)
            setPage4(false)
            setPage5(false)
        } else if (page === 3) {
            setPage1(false)
            setPage2(false)
            setPage3(true)
            setPage4(false)
            setPage5(false)
        } else if (page === 4) {
            setPage1(false)
            setPage2(false)
            setPage3(false)
            setPage4(true)
            setPage5(false)
        } else if (page === 5) {
            setPage1(false)
            setPage2(false)
            setPage3(false)
            setPage4(false)
            setPage5(true)
        }
    }


    const updateFiles = (incommingFiles) => {
        setFiles(incommingFiles);

        const newUrls = incommingFiles.map((file) => URL.createObjectURL(file.file));
        setFileUrls(newUrls);
        //even your own upload implementation
    };
    const removeFile = (id) => {
        const updatedFiles = files.filter((x) => x.id !== id);
        const removedFileIndex = files.findIndex((file) => file.id === id); //find the index of the removed file

        setFiles(updatedFiles);

        // Remove the corresponding URL
        setFileUrls((prevUrls) => {
            const newUrls = [...prevUrls];
            newUrls.splice(removedFileIndex, 1); // Remove the url at the same index
            return newUrls;
        });
    };

    // Rasi → Star mapping using ACTUAL DB star names (Sanskrit/English)
    const ZODIAC_STARS_MAP = {
        'Mesham (Aries)':        ['Ashwini','Bharani','Krittika'],
        'Rishabam (Taurus)':     ['Krittika','Rohini','Mrigashirsha'],
        'Mithunam (Gemini)':     ['Mrigashirsha','Ardra','Punarvasu'],
        'Kadagam (Cancer)':      ['Punarvasu','Pushya','Ashlesha'],
        'Simmam (Leo)':          ['Magha','Purva Phalguni','Uttara Phalguni'],
        'Kanni (Virgo)':         ['Uttara Phalguni','Hasta','Chitra'],
        'Thulam (Libra)':        ['Chitra','Swati','Vishakha'],
        'Viruchigam (Scorpio)':  ['Vishakha','Anuradha','Jyeshtha'],
        'Dhanusu (Sagittarius)': ['Mula','Purva Ashadha','Uttara Ashadha'],
        'Magaram (Capricorn)':   ['Uttara Ashadha','Shravana','Dhanishta'],
        'Kumbam (Aquarius)':     ['Dhanishta','Shatabhisha','Purva Bhadrapada'],
        'Meenam (Pisces)':       ['Purva Bhadrapada','Uttara Bhadrapada','Revati'],
    }

    // Stars filtered by selected zodiac — recomputed every render, no async needed
    const stars = useMemo(() => {
        const zodiacId = registerForm?.values?.additionalInformation?.zodiacSign
        if (!zodiacId || !allStars?.length) return allStars || []
        const zodiacText = zodiacSigns?.find(z => z.value === zodiacId)?.text
            || zodiacSigns?.find(z => z.text === zodiacId)?.text
            || (ZODIAC_STARS_MAP[zodiacId] ? zodiacId : '')
        if (!zodiacText) return allStars || []
        const starNames = ZODIAC_STARS_MAP[zodiacText] || []
        if (!starNames.length) return allStars || []
        const filtered = allStars.filter(s => starNames.some(n => s.text?.toLowerCase() === n.toLowerCase()))
        return filtered.length > 0 ? filtered : allStars
    }, [registerForm?.values?.additionalInformation?.zodiacSign, zodiacSigns, allStars]) // eslint-disable-line

    // Called by FieldSelect onChange — just clear the star when zodiac changes
    const getStarsByZodiac = (zodiacId) => {
        registerForm.getFieldHelpers?.('additionalInformation.star')?.setValue?.('')
    }

    const getPresentAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode/${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data
                    registerForm.setValues({ ...registerForm.values, presentAddress: { ...registerForm.values.presentAddress, city: location.city || registerForm.values.presentAddress?.city, state: location.state || registerForm.values.presentAddress?.state, district: location.district || registerForm.values.presentAddress?.district, pinCode: values } })
                }
            }).catch(() => {})
        } else if (values.length === 0) {
            registerForm.setValues({ ...registerForm.values, presentAddress: { city: '', state: '', district: '', pinCode: '' } })
        }
    }

    const getNativeAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode/${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data
                    registerForm.setValues({ ...registerForm.values, nativeAddress: { ...registerForm.values.nativeAddress, city: location.city || registerForm.values.nativeAddress?.city, state: location.state || registerForm.values.nativeAddress?.state, district: location.district || registerForm.values.nativeAddress?.district, pinCode: values } })
                }
            }).catch(() => {})
        } else if (values.length === 0) {
            registerForm.setValues({ ...registerForm.values, nativeAddress: { city: '', state: '', district: '', pinCode: '' } })
        }
    }

    const sameAddress = (value) => {
        if (value.target.checked) {
            registerForm.setValues({...registerForm.values, contactInformation:{...registerForm.values.contactInformation, isSameAddress: value.target.checked},nativeAddress:{...registerForm.values.presentAddress}})
            // contactForm.setValues({ ...contactForm.values, isSameAddress: value.target.checked, nativeAddress: contactForm.values.presentAddress })
        } else {
            // contactForm.setValues({ ...contactForm.values, isSameAddress: value.target.checked, nativeAddress: { addressLine1: '', addressLine2: '', city: '', state: '', district: '', pinCode: '' } })
            registerForm.setValues({...registerForm.values, contactInformation:{...registerForm.values.contactInformation, isSameAddress: value.target.checked},nativeAddress: { addressLine1: '', addressLine2: '', city: '', state: '', district: '', pinCode: '' }})
        }
    }

    const translateValues = (value, key, actualValue) => {
        if (lang === 'ta' && key === 'firstName') {
            registerForm.setValues({ ...registerForm.values, firstName: actualValue, tFirstName: value })
        } else if (lang === 'ta' && key === 'lastName') {
            registerForm.setValues({ ...registerForm.values, lastName: actualValue, tLastName: value })
        } else if (lang === 'ta' && key === 'surname') {
            registerForm.setValues({ ...registerForm.values, surname: actualValue, tSurname: value })
        }
    }

    const cancel = ()=>{
        if(JSON.stringify(userDetails) !== JSON.stringify(registerForm.values)){
            setOpenSaveAlert(true)
        }else{
            closeEditor();
        }
    }

    // useEffect(()=>{
    //     return ()=>{
    //         cancel()
    //     }
    // },[])

// Recursively mark all fields as touched
// const touchAllFields = (values) => {
//   const touched = {};
//   for (const key in values) {
//     if (typeof values[key] === 'object' && values[key] !== null && !Array.isArray(values[key])) {
//       touched[key] = touchAllFields(values[key]);
//     } else {
//       touched[key] = true;
//     }
//   }
//   return touched;
// };

//     const submitEditForm = async () => {
//   const errors = await registerForm.validateForm(); // Trigger validation

//   registerForm.setTouched(touchAllFields(registerForm.values), true);

//   console.log('Errors:', errors); // Optional: to inspect errors

// //   if (Object.keys(errors).length === 0) {
// //     registerForm.submitForm();
// //   }
// };

 const checkForKids = (values)=>{
    if(values !== 'Never Married'){
        setChildDetails(true)
    }else{
        setChildDetails(false)
        registerForm.setFieldValue('noOfChild', '')
        registerForm.setFieldValue('childDetails', '')
    }
   }


    return (
        <>
            {
                loading || screenLoading? <motion.div className={`w-full ${compactMode ? 'min-h-[320px]' : 'min-h-screen'} flex flex-col justify-center items-center`}>
                    <Spinner/>
                    <p>Loading please wait...</p>
                </motion.div> : <motion.div className={`${compactMode ? 'min-h-0 overflow-visible px-1 pb-8 pt-1 registerBg' : 'w-full h-full overflow-y-scroll'} flex flex-col relative`}>
                    {/* ── Sticky Save/Cancel bar — hidden when embedded (buttons live in SlideOver header) ── */}
                    {!embedded && (
                        <div className="sticky top-0 z-30 flex items-center justify-between gap-3 border-b border-borderColor bg-white/95 px-4 py-3 shadow-sm backdrop-blur-sm">
                            <p className="truncate text-sm font-semibold text-tColor">
                                {registerForm.values.firstName || ''}{' '}
                                {registerForm.values.surname || registerForm.values.lastName || ''}
                                {registerForm.values.refId ? <span className="ml-1.5 text-xs font-normal text-tpColor">· {registerForm.values.refId}</span> : null}
                            </p>
                            <div className="flex shrink-0 items-center gap-2">
                                <Button injectClass="rounded-full" type="secondary" onClick={cancel}>{t('Cancel')}</Button>
                                <Button injectClass="rounded-full min-w-[90px]" type="primary" disabled={submitDisabled} onClick={handleSaveAll}>
                                    {submitDisabled ? 'Saving…' : t('Save')}
                                </Button>
                            </div>
                        </div>
                    )}
                    <motion.div className={`${compactMode ? 'hidden' : 'w-full flex flex-row px-2 md:px-0 justify-between'}`}>
                        <motion.div className="flex flex-row justify-between items-center">
                            {/* <LanguageSwitcher onToggle={(lang) => dispatch(setLanguage(lang))} /> */}
                        </motion.div>
                    </motion.div>
                    {/* Page 1 */}
                    <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                        <motion.div className="w-full gap-2 flex flex-col h-full justify-center">
                            <p className="text-4xl font-bold text-primeColor">{t('Basic Information')}</p>
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                            <FieldSelect
                                injectClass={'bg-white'}
                                label={t('Bride/Groom')}
                                fieldProps={registerForm.getFieldProps('profileType')}
                                fieldMeta={registerForm.getFieldMeta('profileType')}
                                fieldHelper={registerForm.getFieldHelpers('profileType')}
                                edit={true}
                                dataLoaded={true}
                                options={lang === 'en' ? profileTypes : tProfileTypes}
                                onChange={(ev) => setPType(profileTypes.filter((x) => x.value === ev)[0].text)}
                            />
                            <FieldInput injectClass={'bg-white'} label={t(`Educational Qualification`)} placeholder={'B.E, MBA, M.E, BCA ...'} fieldProps={registerForm.getFieldProps('otherEducationalQualification')} fieldMeta={registerForm.getFieldMeta('otherEducationalQualification')} fieldHelper={registerForm.getFieldHelpers('otherEducationalQualification')} edit={true} dataLoaded={true} />
                            <FieldInput disabled={true} injectClass={'bg-white'} label={t(`Reference Number`)}fieldProps={registerForm.getFieldProps('refId')} fieldMeta={registerForm.getFieldMeta('refId')} fieldHelper={registerForm.getFieldHelpers('refId')} edit={false} dataLoaded={true} />
                            <FieldSelect
                                injectClass={'bg-white'}
                                label={t('Marital Status')}
                                fieldProps={registerForm.getFieldProps('maritalStatus')}
                                fieldMeta={registerForm.getFieldMeta('maritalStatus')}
                                fieldHelper={registerForm.getFieldHelpers('maritalStatus')}
                                edit={true}
                                dataLoaded={true}
                                options={lang === 'en' ? maritalStatus : tMaritalStatus}
                                onChange={(ev) => checkForKids(ev)}
                            />
                            {childDetails && <FieldSelect injectClass={'bg-white'} label={t('No of childs')} fieldProps={registerForm.getFieldProps('noOfChild')} fieldHelper={registerForm.getFieldHelpers('noOfChild')} fieldMeta={registerForm.getFieldMeta('noOfChild')} edit={true} dataLoaded={true} options={childOptions}/>}
                            {registerForm.values.noOfChild !== "0" && registerForm.values.noOfChild !== '' && registerForm.values.noOfChild !== null && <FieldInput type='textarea' injectClass={'bg-white'}  label={'Child Details'} fieldProps={registerForm.getFieldProps('childDetails')} fieldHelper={registerForm.getFieldHelpers('childDetails')} fieldMeta={registerForm.getFieldMeta('childDetails')} edit={true} dataLoaded={true}/>} 
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} First Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tFirstName') : registerForm.getFieldProps('firstName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tFirstName') : registerForm.getFieldMeta('firstName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tFirstName') : registerForm.getFieldHelpers('firstName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'firstName', ev.value)} />
                            {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Last Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tLastName') : registerForm.getFieldProps('lastName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tLastName') : registerForm.getFieldMeta('lastName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tLastName') : registerForm.getFieldHelpers('lastName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'lastName', ev.value)} /> */}
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Surname`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tSurname') : registerForm.getFieldProps('surname')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tSurname') : registerForm.getFieldMeta('surname')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tSurname') : registerForm.getFieldHelpers('surname')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'surname', ev.value)} />
                            <FieldInput type="date" dateInjectClass={'bg-white'} label={t(`Date of birth`)} fieldProps={registerForm.getFieldProps('dateOfBirth')} fieldMeta={registerForm.getFieldMeta('dateOfBirth')} fieldHelper={registerForm.getFieldHelpers('dateOfBirth')} edit={true} dataLoaded={true} />
                            {/* <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Height In Cm`)} fieldProps={registerForm.getFieldProps('height')} fieldMeta={registerForm.getFieldMeta('height')} fieldHelper={registerForm.getFieldHelpers('height')} edit={true} dataLoaded={true} onChange={(ev) => convertHeight(ev)} /> */}
                            <motion.div className="flex flex-col gap-2">
                        <label className="font-medium text-sm">{t('Choose height measurement')}</label>

                        <motion.div className="flex items-center gap-4">
                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'cm'}
                                    onChange={() => setHeightType('cm')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In CM')}</span>
                            </label>

                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'ft'}
                                    onChange={() => setHeightType('ft')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In Feet')}</span>
                            </label>
                        </motion.div>
                    </motion.div>
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Height In ${heightType === 'cm' ? 'CM' : 'Feet'}`)} fieldProps={heightType === 'cm' ? registerForm.getFieldProps('height') : registerForm.getFieldProps('heightInFeet')}
                        fieldMeta={heightType === 'cm' ? registerForm.getFieldMeta('height') : registerForm.getFieldMeta('heightInFeet')} fieldHelper={heightType === 'cm' ? registerForm.getFieldHelpers('height') : registerForm.getFieldHelpers('heightInFeet')} edit={true} dataLoaded={true} onChange={(ev) => heightType === 'cm' ? convertHeight(ev) : convertHeightToCm(ev)} />
                            <FieldSelect injectClass={'bg-white'} label={t(`${pType ? pType : ''} Profession`)} fieldProps={registerForm.getFieldProps('profession')} fieldMeta={registerForm.getFieldMeta('profession')} fieldHelper={registerForm.getFieldHelpers('profession')} edit={true} dataLoaded={true} options={occupation} />
                            <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation Detail`)} placeholder="Software Engineer/ Pediatrician/ " fieldProps={registerForm.getFieldProps('occupation')} fieldMeta={registerForm.getFieldMeta('occupation')} fieldHelper={registerForm.getFieldHelpers('occupation')} edit={true} dataLoaded={true} />
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation Location`)} fieldProps={registerForm.getFieldProps('occupationLocation')} fieldMeta={registerForm.getFieldMeta('occupationLocation')} fieldHelper={registerForm.getFieldHelpers('occupationLocation')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary`)} fieldProps={registerForm.getFieldProps('salary')} fieldMeta={registerForm.getFieldMeta('salary')} fieldHelper={registerForm.getFieldHelpers('salary')} edit={true} dataLoaded={true} />
                            <FieldSelect injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary Mode`)} fieldProps={registerForm.getFieldProps('salaryMode')} fieldMeta={registerForm.getFieldMeta('salaryMode')} fieldHelper={registerForm.getFieldHelpers('salaryMode')} edit={true} dataLoaded={true} options={lang === 'en' ? salaryMode : tSalaryMode} />
                        </motion.div>
                    </motion.div>
                    {/* Page 2 */}
                    <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                        <motion.div className="w-full flex gap-2 flex-col h-full justify-center">
                            <p className="text-4xl font-bold text-primeColor">{t('Family Information')}</p>
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father First Name`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherFirstName')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherFirstName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherFirstName')} edit={true} dataLoaded={true} />
                            {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Last Name`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherLastName')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherLastName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherLastName')} edit={true} dataLoaded={true} /> */}
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Surname`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherSurname')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherSurname')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherSurname')} edit={true} dataLoaded={true} />
                            <FieldSelect injectClass={'bg-white'} label={t('Father is alive?')} fieldProps={registerForm.getFieldProps('familyInformation.isFatherAlive')} fieldMeta={registerForm.getFieldMeta('familyInformation.isFatherAlive')} fieldHelper={registerForm.getFieldHelpers('familyInformation.isFatherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                            <FieldInput injectClass={'bg-white'} label={t(`Father Occupation`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherOccupation')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherOccupation')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherOccupation')} edit={true} dataLoaded={true} options={occupation} />
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother First Name`)} fieldProps={registerForm.getFieldProps('familyInformation.motherFirstName')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherFirstName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherFirstName')} edit={true} dataLoaded={true} />
                            {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Last Name`)} fieldProps={registerForm.getFieldProps('familyInformation.motherLastName')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherLastName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherLastName')} edit={true} dataLoaded={true} /> */}
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Surname`)} fieldProps={registerForm.getFieldProps('familyInformation.motherSurname')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherSurname')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherSurname')} edit={true} dataLoaded={true} />
                            <FieldSelect injectClass={'bg-white'} label={t('Mother is alive?')} fieldProps={registerForm.getFieldProps('familyInformation.isMotherAlive')} fieldMeta={registerForm.getFieldMeta('familyInformation.isMotherAlive')} fieldHelper={registerForm.getFieldHelpers('familyInformation.isMotherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                            <FieldInput injectClass={'bg-white'} label={t(`Mother Occupation`)} fieldProps={registerForm.getFieldProps('familyInformation.motherOccupation')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherOccupation')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherOccupation')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Native`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherNative')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherNative')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherNative')} edit={true} dataLoaded={true} />
                            <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Native`)} fieldProps={registerForm.getFieldProps('familyInformation.motherNative')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherNative')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherNative')} edit={true} dataLoaded={true} />
                            {/* <FieldInput injectClass={'bg-white'} label={t(`Number of siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfSiblings')} edit={true} dataLoaded={true} /> */}
                            <FieldInput injectClass={'bg-white'} label={t(`Number of male siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfMaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfMaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfMaleSiblings')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`Number of female siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfFemaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfFemaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfFemaleSiblings')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`No. of female married siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.marriedFemaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.marriedFemaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.marriedFemaleSiblings')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`No. of male married siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.marriedMaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.marriedMaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.marriedMaleSiblings')} edit={true} dataLoaded={true} />
                            <motion.div className="xl:col-span-2">
                            <FieldInput injectClass={'bg-white'} type="textarea" label={t(`Siblings Details`)} fieldProps={registerForm.getFieldProps('familyInformation.siblingsDetails')} fieldHelper={registerForm.getFieldHelpers('familyInformation.siblingsDetails')} fieldMeta={registerForm.getFieldMeta('familyInformation.siblingsDetails')} edit={true} dataLoaded={true}/>
                            </motion.div>
                            <motion.div className="xl:col-span-2">
                            <FieldInput injectClass={'bg-white'} type="textarea" label={t(`Asset Information`)} fieldProps={registerForm.getFieldProps('familyInformation.assetInfo')} fieldHelper={registerForm.getFieldHelpers('familyInformation.assetInfo')} fieldMeta={registerForm.getFieldMeta('familyInformation.assetInfo')} edit={true} dataLoaded={true}/>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    {/* Page 3 */}
                    <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                        <motion.div className="w-full flex gap-2 px-1 flex-col h-full justify-center">
                            <p className="text-4xl font-bold text-primeColor">{t('Additional Information')}</p>
                        </motion.div>
                        <motion.div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldSelect injectClass={'bg-white'} label={t('Zodiac Sign')} fieldProps={registerForm.getFieldProps('additionalInformation.zodiacSign')} fieldMeta={registerForm.getFieldMeta('additionalInformation.zodiacSign')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.zodiacSign')} edit={true} dataLoaded={zodiacSigns.length > 0} options={zodiacSigns} onChange={(ev) => { getStarsByZodiac(ev) }} />
                            <FieldSelect injectClass={'bg-white'} placeholder={t('Star')} label={t(`Star`)} fieldProps={registerForm.getFieldProps('additionalInformation.star')} fieldMeta={registerForm.getFieldMeta('additionalInformation.star')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.star')} edit={true} dataLoaded={true} options={stars} />
                            <FieldSelect injectClass={'bg-white'} placeholder={t('Padham')} label={t(`Padham`)} fieldProps={registerForm.getFieldProps('additionalInformation.padham')} fieldMeta={registerForm.getFieldMeta('additionalInformation.padham')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.padham')} edit={true} dataLoaded={true} options={pathams} />
                            <FieldMultiSelect injectClass={'bg-white'} placeholder={t('Flaws')} label={t(`Flaws`)} fieldProps={registerForm.getFieldProps('additionalInformation.flaws')} fieldMeta={registerForm.getFieldMeta('additionalInformation.flaws')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.flaws')} edit={true} dataLoaded={true} options={lang === 'en' ? flaws : tFlaws} />
                            <div></div>
                        </motion.div>
                        <motion.div className="w-full flex px-1 gap-2 flex-col my-5 justify-center">
                            <p className="text-xl font-bold text-primeColor">{t('Expectations')}</p>
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldMultiSelect injectClass={'bg-white'} label={t(`Zodiac Sign`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedZodiacSigns')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedZodiacSigns')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedZodiacSigns')} edit={true} dataLoaded={true} options={zodiacSigns} />
                            <FieldMultiSelect injectClass={'bg-white'} label={t('Stars')} fieldProps={registerForm.getFieldProps('additionalInformation.expectedStars')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedStars')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedStars')} edit={true} dataLoaded={true} options={allStars} />
                            {/* <FieldInput injectClass={'bg-white'} label={`Perssonality`} fieldProps={registerForm.getFieldProps('expectedPersonality')} fieldMeta={registerForm.getFieldMeta('expectedPersonality')} fieldHelper={registerForm.getFieldHelpers('expectedPersonality')} edit={true} dataLoaded={true} /> */}
                            <FieldInput injectClass={'bg-white'} label={t(`Educational Qualification`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedEducationalQualification')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedEducationalQualification')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedEducationalQualification')} edit={true} dataLoaded={true} />
                            <FieldMultiSelect injectClass={'bg-white'} label={t(`Occupation`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedOccupation')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedOccupation')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedOccupation')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                            <FieldInput injectClass={'bg-white'} label={t(`Salary`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedSalary')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedSalary')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedSalary')} edit={true} dataLoaded={true} />
                            <FieldMultiSelect injectClass={'bg-white'} label={t(`Status`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedStatus')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedStatus')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedStatus')} edit={true} dataLoaded={true} options={lang === 'en' ? status : tStatus} />
                            <FieldInput injectClass={'bg-white'} label={t(`Expectation`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectation')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectation')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectation')} edit={true} dataLoaded={true} />
                            {/* <FieldInput injectClass={'bg-white'} type="password" label={t(`Password`)} fieldProps={registerForm.getFieldProps('password')} fieldMeta={registerForm.getFieldMeta('password')} fieldHelper={registerForm.getFieldHelpers('password')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} type="password" label={t(`Confirm Password`)} fieldProps={registerForm.getFieldProps('confirmPassword')} fieldMeta={registerForm.getFieldMeta('confirmPassword')} fieldHelper={registerForm.getFieldHelpers('confirmPassword')} edit={true} dataLoaded={true} /> */}
                        </motion.div>
                    </motion.div>
                    {/* Page 4 */}
                    <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                        <motion.div className="w-full flex px-1 gap-2 flex-col h-full py-5 justify-center">
                            <p className="text-4xl font-bold text-primeColor">{t('Contact Information')}</p>
                        </motion.div>
                        <motion.div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldInput injectClass={'bg-white'} type="phone" label={t('Mobile Number')} fieldProps={registerForm.getFieldProps('contactInformation.mobileNumber')} fieldMeta={registerForm.getFieldMeta('contactInformation.mobileNumber')} fieldHelper={registerForm.getFieldHelpers('contactInformation.mobileNumber')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} type="phone" label={t('Whatsapp Number')} fieldProps={registerForm.getFieldProps('contactInformation.whatsappNumber')} fieldMeta={registerForm.getFieldMeta('contactInformation.whatsappNumber')} fieldHelper={registerForm.getFieldHelpers('contactInformation.whatsappNumber')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} placeholder={t('Email')} label={t(`Email`)} fieldProps={registerForm.getFieldProps('contactInformation.email')} fieldMeta={registerForm.getFieldMeta('contactInformation.email')} fieldHelper={registerForm.getFieldHelpers('contactInformation.email')} edit={true} dataLoaded={true} />
                            <div></div>
                            <div></div>
                        </motion.div>
                        <motion.div className="w-full flex px-5 flex-col my-5 justify-center">
                            <p className="text-xl font-bold text-primeColor">{t('Present Address')}</p>
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldInput injectClass={'bg-white'} ml={true} length={6} label={t(`Pincode`)} fieldProps={registerForm.getFieldProps('presentAddress.pinCode')} fieldMeta={registerForm.getFieldMeta('presentAddress.pinCode')} fieldHelper={registerForm.getFieldHelpers('presentAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getPresentAddress(ev)} />
                            <FieldInput injectClass={'bg-white'} label={t('Address Line 1')} fieldProps={registerForm.getFieldProps('presentAddress.addressLine1')} fieldMeta={registerForm.getFieldMeta('presentAddress.addressLine1')} fieldHelper={registerForm.getFieldHelpers('presentAddress.addressLine1')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`Address Line 2`)} fieldProps={registerForm.getFieldProps('presentAddress.addressLine2')} fieldMeta={registerForm.getFieldMeta('presentAddress.addressLine2')} fieldHelper={registerForm.getFieldHelpers('presentAddress.addressLine2')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`City`)} fieldProps={registerForm.getFieldProps('presentAddress.city')} fieldMeta={registerForm.getFieldMeta('presentAddress.city')} fieldHelper={registerForm.getFieldHelpers('presentAddress.city')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`District`)} fieldProps={registerForm.getFieldProps('presentAddress.district')} fieldMeta={registerForm.getFieldMeta('presentAddress.district')} fieldHelper={registerForm.getFieldHelpers('presentAddress.district')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`State`)} fieldProps={registerForm.getFieldProps('presentAddress.state')} fieldMeta={registerForm.getFieldMeta('presentAddress.state')} fieldHelper={registerForm.getFieldHelpers('presentAddress.state')} edit={true} dataLoaded={true} />
                            <motion.div className="flex flex-row w-full items-center">
                                <input
                                    type="checkbox"
                                    checked={registerForm.values.contactInformation.isSameAddress}
                                    onChange={(ev) => sameAddress(ev)}
                                />&nbsp;{t('Present Address is your native address')}
                            </motion.div>
                        </motion.div>
                        <motion.div className="w-full flex px-5 flex-col my-5 justify-center">
                            <p className="text-xl font-bold text-primeColor">{t('Native Address')}</p>
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldInput injectClass={'bg-white'} ml={true} length={6} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`Pincode`)} fieldProps={registerForm.getFieldProps('nativeAddress.pinCode')} fieldMeta={registerForm.getFieldMeta('nativeAddress.pinCode')} fieldHelper={registerForm.getFieldHelpers('nativeAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getNativeAddress(ev)} />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t('Address Line 1')} fieldProps={registerForm.getFieldProps('nativeAddress.addressLine1')} fieldMeta={registerForm.getFieldMeta('nativeAddress.addressLine1')} fieldHelper={registerForm.getFieldHelpers('nativeAddress.addressLine1')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`Address Line 2`)} fieldProps={registerForm.getFieldProps('nativeAddress.addressLine2')} fieldMeta={registerForm.getFieldMeta('nativeAddress.addressLine2')} fieldHelper={registerForm.getFieldHelpers('nativeAddress.addressLine2')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`City`)} fieldProps={registerForm.getFieldProps('nativeAddress.city')} fieldMeta={registerForm.getFieldMeta('nativeAddress.city')} fieldHelper={registerForm.getFieldHelpers('nativeAddress.city')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`District`)} fieldProps={registerForm.getFieldProps('nativeAddress.district')} fieldMeta={registerForm.getFieldMeta('nativeAddress.district')} fieldHelper={registerForm.getFieldHelpers('nativeAddress.district')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`State`)} fieldProps={registerForm.getFieldProps('nativeAddress.state')} fieldMeta={registerForm.getFieldMeta('nativeAddress.state')} fieldHelper={registerForm.getFieldHelpers('nativeAddress.state')} edit={true} dataLoaded={true} />
                        </motion.div>
                    </motion.div>
                    <motion.div className="h-fit my-5 gap-5 w-full grid grid-cols-1">
                        <motion.div className="w-full flex gap-2 flex-col h-full justify-center">
                            <p className="text-4xl font-bold text-primeColor">{t('Birth Information')}</p>
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldInput injectClass={'bg-white'} type="time" label={t(`Birth Time`)} fieldProps={registerForm.getFieldProps('birthTime')} fieldMeta={registerForm.getFieldMeta('birthTime')} fieldHelper={registerForm.getFieldHelpers('birthTime')} edit={true} dataLoaded={true} onChange={(ev) => getPresentAddress(ev)} />
                            <FieldInput injectClass={'bg-white'} label={t('Birth Place')} fieldProps={registerForm.getFieldProps('birthPlace')} fieldMeta={registerForm.getFieldMeta('birthPlace')} fieldHelper={registerForm.getFieldHelpers('birthPlace')} edit={true} dataLoaded={true} />
                            <FieldSelect injectClass={'bg-white'} label={t(`Dhisai Iruppu`)} fieldProps={registerForm.getFieldProps('thisaiIruppu')} fieldMeta={registerForm.getFieldMeta('thisaiIruppu')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppu')} edit={true} dataLoaded={true} options={lang === 'en' ? dhisa : tDhisa} />
                            <FieldInput injectClass={'bg-white'} label={t(`Dhisai Iruppu Date`)} fieldProps={registerForm.getFieldProps('thisaiIruppuDate')} fieldMeta={registerForm.getFieldMeta('thisaiIruppuDate')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppuDate')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`Dhisai Iruppu Month`)} fieldProps={registerForm.getFieldProps('thisaiIruppuMonth')} fieldMeta={registerForm.getFieldMeta('thisaiIruppuMonth')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppuMonth')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`Dhisai Iruppu Year`)} fieldProps={registerForm.getFieldProps('thisaiIruppuYear')} fieldMeta={registerForm.getFieldMeta('thisaiIruppuYear')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppuYear')} edit={true} dataLoaded={true} />
                        </motion.div>
                    </motion.div>
                    <motion.div className="h-full w-full overflow-scroll grid grid-cols-1 gap-10">
                        <motion.div className="w-full flex px-1 gap-2 flex-col h-full py-5 justify-center">
                            <p className="text-4xl font-bold text-primeColor">{t('Upload Horoscope Information')}</p>
                        </motion.div>
                        <motion.div className="w-full grid grid-cols-1 xl:grid-cols-2 gap-8">
                            {/* ── ராசி Kattam ── */}
                            <div className="flex flex-col gap-3">
                                <div className="flex items-center gap-2 px-1">
                                    <span className="text-base font-bold text-primeColor">ராசி கட்டம்</span>
                                    <span className="text-sm text-tpColor">(Rasi Chart)</span>
                                </div>
                                <div className="rounded-2xl border border-borderColor bg-white p-4 shadow-sm">
                                    <RasiKattam
                                        setRasiValues={(ev) => setRasiValues(ev)}
                                        rasiValues={rasiValues}
                                        kattamOuterInjectClass="w-full"
                                        kattamInnerInjectclass="min-h-[90px] sm:min-h-[110px]"
                                    />
                                </div>
                            </div>
                            {/* ── அம்சம் Kattam ── */}
                            <div className="flex flex-col gap-3">
                                <div className="flex items-center gap-2 px-1">
                                    <span className="text-base font-bold text-primeColor">அம்சம் கட்டம்</span>
                                    <span className="text-sm text-tpColor">(Amsa Chart)</span>
                                </div>
                                <div className="rounded-2xl border border-borderColor bg-white p-4 shadow-sm">
                                    <AmsaKattam
                                        setAmsaValues={(ev) => setAmsaValues(ev)}
                                        amsaValues={amsaValues}
                                        kattamOuterInjectClass="w-full"
                                        kattamInnerInjectclass="min-h-[90px] sm:min-h-[110px]"
                                    />
                                </div>
                            </div>
                        </motion.div>
                        <motion.div className="w-full flex flex-row justify-end gap-3">
                            {!embedded && <Button injectClass={'rounded-full'} type="secondary" onClick={cancel}>{t('Cancel')}</Button>}
                            <motion.div className="w-96 flex flex-row justify-start">
                                <Button injectClass={'rounded-full w-full'} type="primary" disabled={submitDisabled} onClick={handleSaveAll}>{submitDisabled ? 'Saving…' : t('Save')}</Button>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </motion.div >
            }
            <Dialog title={t('Unsaved Changes')} showDialog={openSaveAlert} onClose={() => { setOpenSaveAlert(false) }}>
                <motion.div className="h-full w-full flex flex-col gap-5 px-2 py-2">
                    <p>{t('You have unsaved changes. Do you want to go back?')}</p>
                    <motion.div className="flex justify-center gap-2">
                        <Button type="primary" injectClass="rounded-md" onClick={closeEditor}>
                            {t('Yes')}
                        </Button>
                        <Button type="secondary" injectClass="rounded-md" onClick={() => {setOpenSaveAlert(false) }}>
                            {t('No')}
                        </Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </>
    )
}

export default EditUser
